import React, { useMemo, useCallback } from "react";
import { ChevronsUpDown } from "lucide-react";
import OwnerHeaderCell from "./OwnerHeaderCell";
import StageRow from "./StageRow";

/**
 * Renders the full stage x owner assignment grid.
 */
export default function StageAssignmentTable({ stages, owners, setOwners }) {

  const sortStagesByOrder = () => {
    return [...stages].sort(
      (a, b) => (a.display_order ?? 0) - (b.display_order ?? 0)
    );
  };

  const sortedStages = useMemo(() => sortStagesByOrder(stages), [stages]);


  return (
    <div className="px-6 sm:px-8 pb-6">
      <div className="overflow-x-auto rounded-xl border border-slate-200/80 bg-white shadow-sm">
        <table className="w-full min-w-[640px] border-collapse">
          <thead>
            <tr className="bg-slate-50/70 border-b border-slate-100">
              <th
                scope="col"
                className="whitespace-nowrap px-6 py-4 text-left font-sans text-xs font-semibold text-slate-500 uppercase tracking-wider"
              >
                <span className="inline-flex items-center gap-1.5">
                  Workflow Stage
                  <ChevronsUpDown className="h-3.5 w-3.5 text-slate-400" aria-hidden="true" />
                </span>
              </th>
              {owners.map((owner, index) => (
                <OwnerHeaderCell
                  key={owner.user_id || owner.user.id}
                  owner={owner}
                  index={index}
                  setOwners={setOwners}
                />
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {sortedStages.map((stage, index) => (
              <StageRow
                key={stage.id}
                stage={stage}
                owners={owners}
                setOwners={setOwners}
                accentIndex={index}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}